import React from 'react';
import { RequestProvider } from '@shootsta/common-react';
import { getOrganisationStockAccessQuery } from '../api';
import StockUnlimitedBannerComponent from '../components/StockUnlimitedBanner';

type Props = {
  enabled: string | boolean;
  organisationId?: string;
  dismissedNotificationForOrg: string | null;
  onDismiss: (orgId?: string) => void;
};

export default function StockUnlimitedBanner(props: Props) {
  const { organisationId } = props;

  if (!organisationId) {
    return null;
  }

  return (
    <RequestProvider
      requests={{
        getOrganisationStockAccess: getOrganisationStockAccessQuery()
      }}
    >
      {(requests) => (
        <StockUnlimitedBannerComponent
          {...props}
          getOrganisationStockAccess={requests.getOrganisationStockAccess}
        />
      )}
    </RequestProvider>
  );
}
